import styles from "./hidden-button.module.scss";

function HiddenButton(props: any) {
  return (
    <button className={styles.hiddenButton} type="button" {...props} />
  );
}

export default HiddenButton;
